import * as Yup from 'yup';
import { IModel } from '~/lib/model';

export interface ISupplyPackage extends IModel {
    name: string;
    description: string;
    rules: string;
}

export const SupplyPackageSchema = Yup.object().shape<ISupplyPackage>({
    id: Yup.number().nullable(),
    name: Yup.string().required().nullable(false).max(100),
    description: Yup.string().nullable(false).max(300),
    rules: Yup.string().required().nullable(false),
});

export const defaultSupplyPackage: ISupplyPackage = {
    id: null,
    name: '',
    description: '',
    rules: '',
};
